import {
  AspectRatioConfig,
  useVideoFlow,
  VideoFlowProps,
  VideoFlowStep,
} from './flows';
import { VideoWizardObjective } from './types';
import VideoWizard from './VideoWizard';

export {
  AspectRatioConfig,
  VideoFlowStep as VideoWizardStep,
  useVideoFlow,
  VideoFlowProps,
  VideoWizardObjective,
};

export default VideoWizard;
